import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {IconContainerProps, ColorTheme} from "../types";

export const ArrowBoldIcon = (props: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const {colorTheme} = props;
  const isLight = colorTheme === ColorTheme.light;
  const fillColor = isLight ? theme.color.wh : theme.color.b1;

  const GapSVG = (
    <svg viewBox="0 0 13.909 13.194" xmlns="http://www.w3.org/2000/svg">
      <g>
        <g>
          <path d="M13.153 7.201H0V6.168h13.153Z" fill={fillColor} />
          <path
            d="m6.576.726.727-.727 6.599 6.599-.727.727Z"
            fill={fillColor}
          />
          <path
            d="m12.876 6.168.727.727-6.299 6.299-.727-.727 6.3-6.3Z"
            fill={fillColor}
          />
        </g>
      </g>
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: null,
    [Brands.BananaRepublic]: null,
    [Brands.BananaRepublicFactoryStore]: null,
    [Brands.Gap]: GapSVG,
    [Brands.GapFactoryStore]: GapSVG,
    [Brands.OldNavy]: null,
    crossBrand: null,
  };

  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
